import { datadogLogs } from '@datadog/browser-logs';

export default class Logger {
  static initializeLogger() {
    console.info(import.meta.env.VITE_ENV);
    if (this.shouldLog()) {
      datadogLogs.init({
        clientToken: 'pubbec3d512a0179a4b6df114936813523b',
        forwardErrorsToLogs: true,
        sampleRate: 100,
        env: import.meta.env.VITE_ENV,
        service: `chancellor-${import.meta.env.VITE_ENV}`,
        silentMultipleInit: true,
        version: 'latest',
      });
    }
  }

  static logRouteChange(newRoute: string) {
    datadogLogs.logger.info('route-change', { newRoute });
  }

  static setupLoggerContext(userId: string) {
    datadogLogs.addLoggerGlobalContext('id', userId);
  }

  private static shouldLog() {
    return (
      import.meta.env.VITE_ENV === 'uat' ||
      import.meta.env.VITE_ENV === 'staging' ||
      import.meta.env.VITE_ENV === 'prod'
    );
  }
}
